"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Busy = void 0;
var Busy;
(function (Busy) {
    Busy["Normal"] = "u-busy";
    Busy["Large"] = "u-busy-large";
})(Busy = exports.Busy || (exports.Busy = {}));
//# sourceMappingURL=Busy.js.map